import { ProductActions } from './ProductActions';

/**
 * This reducer should listen to answer change events and ensure the state is up to date
 */
const productReducer = (state, action) => {
  switch (action.type) {
    case ProductActions.PRODUCT_CART_UPDATE_COMPLETED: {
      const {
        productCart,
        productCartKey
      } = action;
      return {
        ...state,
        [productCartKey]: productCart
      };
    }

    default:
      return state;
  }
};

export default productReducer;
